import { GeneralDvmExamTable } from 'modules/donor/components/GeneralDvmExamTable';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { useTranslation } from 'react-i18next';

const DvmExamPage = () => {
  const { t } = useTranslation('donor.DvmExamPage');

  return (
    <>
      <ProfileSideMenuWrapper title={t('title')}>
        <GeneralDvmExamTable />
      </ProfileSideMenuWrapper>
    </>
  );
};

export default DvmExamPage;
